<script setup lang="ts">
import StatusDot from './StatusDot.vue'
import type { Tone } from '~/utils/state'

/** Toolbar filter: the tone lives in the dot, the words stay neutral. No tone = the "All" chip, no dot. */
defineProps<{ label: string; count?: number; tone?: Tone; active?: boolean }>()
</script>

<template>
  <button
    type="button"
    class="hit num inline-flex h-[var(--toolbar-control-height)] shrink-0 items-center gap-1.5 whitespace-nowrap rounded-[var(--radius-compact)] border px-[var(--measure-7px)] text-[length:var(--type-fine)] font-medium"
    :class="active ? 'border-primary/50 text-foreground' : 'border-border text-sidebar-foreground hover:bg-muted'"
  >
    <StatusDot v-if="tone" status="" :tone="tone" />{{ label }} {{ count }}
  </button>
</template>
